import React from 'react';
import ABOUT_DATA from '../../utils/aboutData';

export default function LeftContainer() {
    const sections = [
        { title: ABOUT_DATA.our_story.heading, content: ABOUT_DATA.our_story },
        { title: ABOUT_DATA.our_mission.heading, content: ABOUT_DATA.our_mission },
        { title: ABOUT_DATA.looking_ahead.heading, content: ABOUT_DATA.looking_ahead },
    ];

    return (
        <div className="flex flex-col md:gap-12 gap-6">
            {/* First Section */}
            <div className="flex flex-col text-gray-800 font-medium gap-5">
                {Object.values(ABOUT_DATA.first_div).map((text, index) => (
                    <h2 key={index}>{text}</h2>
                ))}
            </div>

            {/* Images */}
            <img src={ABOUT_DATA.bulb_img} alt="Bulb" />

            {/* Dynamic Sections */}
            {sections.map(({ title, content }, index) => (
                <div key={index}>
                    <h2 className="font-bold text-[#111B31] text-2xl md:text-3xl">{title}</h2>
                    <div className="flex flex-col text-gray-800 font-medium gap-5 sm:mt-5 mt-2">
                        {Object.values(content).slice(1).map((para, i) => (
                            <p key={i}>{para}</p>
                        ))}
                    </div>
                </div>
            ))}

            {/* Final Image */}
            <img src={ABOUT_DATA.students_img} alt="Students" />
        </div>
    );
}
